/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import * as FPT from '../../utility/fpt';
import * as AppActions from '../../actions/AppActions';
import AppStore from '../../stores/AppStore';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import TemplateData, { localsMessages } from '../../utility/getTemplateData';
import { isLTR as isLeftToRight } from '../../utility/helper';
import { loadBodyMovin } from '../../utility/lazyLoader';
import { formatAmount } from '../../utility/formator';
import { sanitize } from '../../utility/domUtils';
import RecurringInfo from './RecurringInfo';
import { Checkbox, Tooltip, Modal } from '@paypalcorp/pp-react';
import { preventFormSubmitOnTooltipClick } from '../../utility/fixPpReactToolTip';

const orgname = TemplateData.donationName ? TemplateData.donationName : '';
const isLTR = isLeftToRight();
let texts = localsMessages('common/recurring-checkbox');
let textsOr = localsMessages('common/orLine');
let isContinue = false;

const styles = StyleSheet.create({
  wrapper: {},
  centered: {
    display: 'flex',
    justifyContent: 'center',
  },
  toolWrapper: {
    display: 'inline-block',
    position: 'relative',
    margin: '0',
    paddingBottom: '10px',
  },
  toolCheckboxWrapper: {
    position: 'absolute',
    width: 'inherit',
    display: 'inline',
  },
  toolCheckbox: {
    ':before': {
      overflow: 'hidden',
    },
  },
  toolBlurb: {
    fontSize: '15px',
    lineHeight: '20px',
    marginLeft: '40px',
    position: 'relative',
    zIndex: 2,
  },
  tipIcon: {
    position: 'relative',
    color: '#005EA6',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  helpIcon: {
    textDecoration: 'none',
    color: '#50c7f9',
    fontWeight: 600,
  },
  helpWrapper: {},
  helpTxt: {
    border: '1px solid #50c7f9',
    lineHeight: '1.8',
    textAlign: 'left',
    borderRadius: 6,
    padding: '15px 10px 5px',
    display: 'flex',
    width: '100%',
    maxWidth: 460,
    margin: '0 auto 25px auto',
  },
  helpP: {
    fontSize: 14,
  },
  helpP2: {
    fontSize: 14,
  },
  perMonth: {
    fontSize: 15,
    position: 'relative',
    top: '-5px',
  },
  splitterDiv: {
    width: '100%',
    overflow: 'hidden',
    padding: '8px',
  },
  splitterP: {
    fontSize: 15,
    marginBottom: 15,
    display: 'inline',
  },
  columnLeft: {
    width: 20,
    float: 'left',
  },
  columnRight: {
    maxWidth: 360, // container 400px, padding 8 + 8 px, leftMargin 20px
    width: '90%',
    marginLeft: 30,
    marginBottom: 8,
    lineHeight: 1.3,
  },
  animationWrapper: {
    width: '100%',
    position: 'absolute',
    height: 125,
    marginTop: -125,
  },
  animationContainer: {
    transform: isLTR ? 'scaleX(1)' : 'scaleX(-1)',
    height: 250,
    width: 250,
    marginLeft: -35,
  },
  recurringButton: {
    width: '100%',
    padding: 20,
    borderRadius: '3rem',
    fontSize: 15,
    marginBottom: 0,
  },
  borderOnly: {
    background: 'transparent',
    color: '#0070ba',
  },
  divider: {
    position: 'relative',
    borderBottom: '1px solid #ccc',
    textAlign: 'center',
    margin: '0 0 20px',
  },
  dividerContent: {
    position: 'relative',
    textAlign: 'center',
    backgroundColor: '#fff',
    display: 'inline-block',
    margin: 0,
    top: 9,
    padding: '0 10px',
    fontSize: 18,
  },
  verticalCentered: {
    display: 'flex',
    alignItems: 'center',
  },
});

class RecurringCheckBox extends React.Component {
  constructor(props) {
    super(props);
    const amount = AppStore.getDonationAmount() || '';
    const currency = AppStore.getDonationCode() || '';
    this.state = {
      showhelp: this.props.status,
      formatedAmount: formatAmount({ currency: currency, value: amount }),
    };
  }

  componentDidMount() {
    this.dispatcherToken = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_AMOUNT') {
        const { action: { item: { amount = 0 } = {} } = {} } = payload;
        this.updateAmount(amount);
      }
    });

    preventFormSubmitOnTooltipClick();
  }

  componentWillUnmount = () => {
    isContinue = this.props.continue;
    AppDispatcher.unregister(this.dispatcherToken);
  };

  loadAnimation(display) {
    if (!display) {
      return;
    }
    loadBodyMovin().then(([bodymovin, animationData]) => {
      // Animation is displayed after bodymovin files are downloaded
      // On slow connections, user may click the checkbox a few times before
      // the JS files are downloaded
      if (this.state.isAnimating) {
        return;
      }
      this.setState({
        isAnimating: true,
      });
      bodymovin.loadAnimation({
        // eslint-disable-line
        container: document.getElementById('animationContainer'),
        renderer: 'svg',
        loop: 1,
        autoplay: true,
        animationData,
      });
      // Destroying with timeout
      setTimeout(() => {
        bodymovin.destroy(); // eslint-disable-line
        this.setState({
          isAnimating: false,
        });
      }, 1000);
    });
  }

  updateAmount = (value) => {
    const currency = AppStore.getDonationCode() || '';
    this.setState({ formatedAmount: formatAmount({ currency, value }) });
  };

  handleChange = (ev) => {
    let { showhelp } = this.state;
    let isChecked = ev.target.checked;
    let chkBxStatus = isChecked ? 'checked' : 'unchecked';

    this.loadAnimation(isChecked);

    AppActions.changeRecurring({
      recurring: chkBxStatus,
    });
    FPT.trackLinkClickWithData('recurringChkBx', {
      checkbox: chkBxStatus,
    });

    this.props.handleChange(isChecked);

    this.setState({ showhelp: (showhelp = !showhelp) });
  };

  createMarkup = (content) => {
    return { __html: content };
  };

  render() {
    let { recurring_label, perMonth } = texts.rp;

    const checked = { checked: false };
    if (this.props.status) {
      checked.checked = true;
    }

    const shouldLeftAlignRecurringCheckbox =
      TemplateData.coverFeeEnabled || TemplateData.anonymousEnabled;

    return (
      <div
        className={`ppvx_row ${
          shouldLeftAlignRecurringCheckbox
            ? 'recurring-checkbox-left-align'
            : ''
        }`}
        id="recurringCheckboxContainer"
      >
        <div
          className={`ppvx_col-sm-12 ${
            shouldLeftAlignRecurringCheckbox ? 'padding-0' : ''
          }`}
        >
          {isContinue ? (
            <div className="ppvx_d-flex ppvx_justify-content-center">
              <span>{perMonth}</span>
            </div>
          ) : (
            <div
              className={`ppvx_d-flex ${
                !shouldLeftAlignRecurringCheckbox
                  ? 'ppvx_justify-content-center'
                  : 'ppvx_justify-content-left'
              } ppvx_align-items-baseline`}
            >
              <div className={css(styles.toolWrapper)}>
                <div
                  className={css(styles.animationWrapper)}
                  id="animationWrapper"
                  style={{ display: this.state.isAnimating ? 'block' : 'none' }}
                >
                  <div
                    className={css(styles.animationContainer)}
                    id="animationContainer"
                  ></div>
                </div>
                <div className={css(styles.verticalCentered)}>
                  <Checkbox
                    className="inline-block"
                    label={recurring_label}
                    name="recurringCheckbox"
                    id="recurringCheckbox"
                    onChange={this.handleChange}
                    value={this.props.status}
                    {...checked}
                  />
                  <Tooltip
                    name="recurring-checkbox-tooltip"
                    description={`${texts.rp.tooltipp2}\n\n${texts.rp.tooltipp1}`}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {this.props.status && !isContinue && (
          <div className="ppvx_col-12">
            <RecurringInfo
              orgName={sanitize(orgname)}
              amount={this.state.formatedAmount}
            />
          </div>
        )}
      </div>
    );
  }
}

RecurringCheckBox.propTypes = {
  handleChange: PropTypes.func,
  hasRecurringHelp: PropTypes.bool,
  status: PropTypes.bool,
  continue: PropTypes.bool,
};

RecurringCheckBox.defaultProps = {
  handleChange: () => {},
};

export default RecurringCheckBox;
